interface ILegacyUpgradePopupProps {
  type: string
  openerRef: string
}

/**
 * Opens the pricing cards popup — the upgrade-popup bundle's full-screen plan
 * cards — which replaces the generic upgrade popup. While the deployed bundle
 * predates it, falls back to the legacy popup with the original props, so the
 * rollout can't strand users behind a missing function.
 */
export const openPricingCardsPopup = (
  legacyProps: ILegacyUpgradePopupProps
): void => {
  if (window.openSubscriptionCardsPopup) {
    window.openSubscriptionCardsPopup({
      type: legacyProps.type,
      openerRef: legacyProps.openerRef
    })
    return
  }

  window.openUpgradePopup(legacyProps)
}
